import { createSearchParams } from "react-router-dom"

import { paths } from "@src/app/paths"
import { router } from "@src/pages"
import { TourStepBase } from "@src/widgets/onboarding/classes/TourStepBase"
import {
  ONBOARDING_TOURS,
  TOUR_MODAL_PLACEMENTS,
} from "@src/widgets/onboarding/types"
import { SettingsSecurityTourStepUi } from "@src/widgets/onboarding/ui/tours/MandatoryInitialSetup/steps/SettingsSecurityTourStepUi"
import { OnboardingStepComponentWrapProps } from "@src/widgets/onboarding/ui/tours/OnboardingStepComponentWrap"

export class SettingsSecurityStep extends TourStepBase {
  component = SettingsSecurityTourStepUi
  name = `${ONBOARDING_TOURS.MANDATORY_INITIAL_SETUP}_SettingsSecurity`

  constructor() {
    super({
      highlightElements: ["#SETTINGS_SECURITY_2FA_BLOCK"],
      placement: TOUR_MODAL_PLACEMENTS.TOP_RIGHT,
    })
  }

  action() {
    return router.navigate({
      pathname: paths.settings,
      search: `?${createSearchParams({ tab: "sp" })}`,
    })
  }

  popupProps(): Omit<OnboardingStepComponentWrapProps, "children"> {
    return {
      pic: this.name,
      subtitle: "Enhance the security of your transactions even further!",
      title: "2FA Security",
    }
  }
}
